import FormSelect from 'components/Select/FormSelect';
import React, { useEffect } from 'react';
import { ITotalPrice, IGetCategoriesShort, IGetCategoriesShortResponse } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCategoriesShortInfo } from 'backend/categories';

interface IAdditionalDishCategorySelect {
	setAdditionalDishCategory: (value: Nullable<string>) => void;
	totalPrices: ITotalPrice[];
}

const AdditionalDishCategorySelect: React.FC<IAdditionalDishCategorySelect> = ({
	totalPrices,
	setAdditionalDishCategory,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetCategoriesShortResponse,
		IGetCategoriesShort
	>(totalPrices.length ? getCategoriesShortInfo : null, {
		restaurantIds: totalPrices.map((el) => el.restaurantId),
		type: 'AdditionalIngredients',
	});

	useEffect(() => {
		refetch();
	}, [totalPrices]);

	return (
		<FormSelect
			name="selectedAdditionalDishCategory"
			label="categoryLabel"
			options={response?.data.categories}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			disabled={!totalPrices.length || loading}
			onChange={setAdditionalDishCategory}
		/>
	);
};

export default React.memo(AdditionalDishCategorySelect);
